// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IlDO","left":"styles_left__1qRT4"};